export const Links = {
  FACEBOOK: 'https://www.facebook.com/junior.barrientos.31?mibextid=ZbWKwL',
  WHATSAPP: 'https://wa.link/bzzza0',
  TIKTOK: 'https://www.tiktok.com/@proyectos.y.proce?_t=8qjaNMDELHp&_r=1',
};

export const Contact = {
  TELEPHONE: null,
  ADDRESS: '9761 SW 9TH CT Pembroke PInes FL 33025',
  SCHEDULE: null,
};

export const SOURCE = 'chambea';
